import React, { useEffect, useMemo, useState } from "react";
import { getConfig } from "../../../../../network/auth";
import axios from "axios";
import { baseUrl } from "../../../../../network/constants/constants";
import { Col, Row, Spinner } from "react-bootstrap";
import ServiceAlertTable from "./components/serviceAlertTable";
import { Alert, Button, Chip, Snackbar, Tooltip } from "@mui/material";
import AcceptPopup from "./components/acceptPopup";
import CancelPopup from "./components/cancelPopup";
import SearchField from "../../../../customComponent/searchField/searchField";

const OtherServiceAlert = () => {
  const [otherServiceAlert, setOtherServiceAlert] = useState([]);
  const [workerList, setWorkerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAlertId, setSelectedAlertId] = useState("");
  const [openAccept, setOpenAccept] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [description, setDescription] = useState("");
  const [search, setSearch] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  
    const [searchValue, setSearchValue] = useState("");
  
    const handleSearchChange = (event) => {
      setSearchValue(event.target.value);
    };

  const handleOpenAccept = (id, desc) => {
    setSelectedAlertId(id);
    setOpenAccept(true);
    setDescription(desc);
  };

  const handleCloseAccept = (id) => {
    setSelectedAlertId("");
    setOpenAccept(false);
  };

  const handleOpenCancel = (id) => {
    setSelectedAlertId(id);
    setOpenCancel(true);
  };

  const handleCloseCancel = (id) => {
    setSelectedAlertId("");
    setOpenCancel(false);
  };

  const handleAdminAccept = (id, workerId, status, dateTimeDescription) => {
    setLoading(true);
    const { booked_at, description } = dateTimeDescription;

    const payload = {
      status: status,
      worker: workerId,
      booked_at: booked_at,
      description: description,
    };
    console.log(payload);

    axios
      .put(
        `${baseUrl}superadmin/other-service-booking-alert-update/${id}/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.headers.Authorization,
          },
        }
      )
      .then((response) => {
        setSnackbar({
          open: true,
          message: "Assigned to a worker successfully",
          severity: "success",
        });
        fetchOtherServiceBooking();
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: "Something went wrong",
          severity: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleAdminReject = (id, status) => {
    setLoading(true);

    const payload = {
      status: status,
    };

    axios
      .put(
        `${baseUrl}superadmin/other-service-booking-alert-update/${id}/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.headers.Authorization,
          },
        }
      )
      .then((response) => {
        fetchOtherServiceBooking();
      })
      .catch((error) => {
        console.error("Error updating other booking status:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const filteredBooking = otherServiceAlert.filter((booking) =>
    Object.entries(booking).some(([key, value]) => {
      if (Array.isArray(value)) {
        return value.some((item) =>
          item.toString().toLowerCase().includes(searchValue.toLowerCase())
        );
      }
  
      if (typeof value === "boolean") {
        
        const stringValue =
          key === "is_paid"
            ? value
              ? "Paid"
              : "Pending"
            : key === "is_booked"
            ? value
              ? "Booked"
              : "Available"
            : "";
  
        return stringValue.toLowerCase().includes(searchValue.toLowerCase());
      }
  
      return (
        value &&
        value.toString().toLowerCase().includes(searchValue.toLowerCase())
      );
    })
  );
  
  
  const displayBooking = searchValue ? filteredBooking : otherServiceAlert;

  const alertwithIndex = displayBooking.map((alert, index) => ({
    ...alert,
    displayIndex: index + 1,
  }));
  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "ID", width: 90 },
    {
      field: "description",
      headerName: "Booking Description",
      width: 250,
    },
    { field: "name", headerName: "Customer Name", width: 150 },
    { field: "phone", headerName: "Customer Number", width: 150 },
    { field: "address", headerName: "Customer Address", width: 170 },
    {
      field: "created_at",
      headerName: "Booked at",
      width: 200,
      renderCell: (params) => {
        const rawDate = params.row?.created_at;
    
        if (!rawDate) return "-";
    
        const dateObj = new Date(rawDate);
    
        if (isNaN(dateObj.getTime())) return "-";
    
        const formattedDate = dateObj.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
    
        const formattedTime = dateObj.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
    
        return (
          <div style={{ lineHeight: "1.3", padding: "8px 0" }}>
            <span style={{ fontWeight: "500" }}>{formattedDate}</span>
            <br />
            <span style={{ color: "#666", fontSize: "0.85rem" }}>{formattedTime}</span>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        let chipColor;

        switch (params.value) {
          case "Waiting":
            chipColor = "warning";
            break;
          case "Accepted":
            chipColor = "success";
            break;
          case "Cancelled":
            chipColor = "error";
            break;
          case "Estimated":
            chipColor = "primary";
            break;
          case "Completed":
            chipColor = "secondary";
            break;
          default:
            chipColor = "default";
        }

        return (
          <Chip
            label={params.value}
            color={chipColor}
            style={{
              color: "white",
              minWidth: "100px",
            }}
          />
        );
      },
    },
    {
      field: "is_booked",
      headerName: "Booking Status",
      width: 150,
      renderCell: (params) => {
        const isBooked = params.value; 
        const tooltipTitle = isBooked ? params.row.booked_method || "N/A" : ""; 
    
        return (
          <Tooltip
            title={tooltipTitle}
            arrow
            placement="top"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#333",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "8px",
                  borderRadius: "6px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                },
              },
            }}
          >
            <span
              style={{
                color: isBooked ? "green" : "red",
                fontWeight: "bold",
                minWidth: "100px",
                display: "inline-block",
                textAlign: "center",
                cursor: isBooked ? "pointer" : "default",
              }}
            >
              {isBooked ? "₹100 Taken" : "-"}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "is_paid",
      headerName: "Final Payment Status",
      width: 150,
      renderCell: (params) => (
        <span style={{ color: params.value ? "green" : "red", fontWeight: "bold"}}>
          {params.value ? "Paid" : "Pending"}
        </span>
      ),
    },
    {
      field: "rating",
      headerName: "Rating",
      width: 150,
      renderCell: (params) => {
        const rating = params.value?.rating || "No Rating";
        const comment = params.value?.comment;
  
        const ratingColors = {
          Excellent: "success",
          Good: "primary",
          Satisfied: "info",
          "Not Satisfied": "warning",
          Poor: "error",
          "No Rating": "default",
        };
    
        return (
          <Tooltip
            title={comment ? comment : ""}
            arrow
            placement="top"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#333",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "8px",
                  borderRadius: "6px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                },
              },
            }}
          >
            <Chip
              label={rating}
              color={ratingColors[rating] || "default"}
              sx={{ cursor: comment ? "pointer" : "default" }}
            />
          </Tooltip>
        );
      },
    },
    { field: "payment_method", headerName: "Payment Method", width: 130 },
    { field: "booking_price", headerName: "Booking Price", width: 130 },
    {
      field: "acceptReject",
      headerName: "Actions",
      width: 400,
      sortable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="outlined"
            color="success"
            style={{ marginRight: "5px" }}
            onClick={() =>
              handleOpenAccept(params.row.id, params.row.description)
            }
          >
            Accept
          </Button>
          <Button
            variant="outlined"
            color="error"
            style={{ marginRight: "5px" }}
            onClick={() => {
              handleOpenCancel(params.row.id);
            }}
          >
            Cancel
          </Button>
        </>
      ),
    },
  ];

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchOtherServiceBooking = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/other-service-booking-alerts/`, config)
      .then((response) => {
        setOtherServiceAlert(response.data);
      })
      .catch((error) => {
        console.error("other service Alert Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchWorkers = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/ServiceMan/?query=${search}`, config)
      .then((response) => {
        setWorkerList(response.data);
      })
      .catch((error) => {
        console.error("other service worker Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchOtherServiceBooking();
    fetchWorkers();
  }, []);

  return (
    <div>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
        <Row>
          <Col>
          <SearchField searchValue={searchValue} handleSearchChange={handleSearchChange}/>
          </Col>
        </Row>
        <Row>
        <ServiceAlertTable
          otherServiceAlert={alertwithIndex}
          columns={columns}
        />
        </Row>
        </>
       
      )}
      <AcceptPopup
        openAccept={openAccept}
        onClose={handleCloseAccept}
        selectedAlertId={selectedAlertId}
        handleAdminAccept={handleAdminAccept}
        fetchWorkers={fetchWorkers}
        workerList={workerList}
        description={description}
        setSearch={setSearch}
      />
      <CancelPopup
        openCancel={openCancel}
        onClose={handleCloseCancel}
        selectedAlertId={selectedAlertId}
        handleAdminReject={handleAdminReject}
      />
       <Snackbar
             open={snackbar.open}
             autoHideDuration={6000}
             onClose={() => setSnackbar({ ...snackbar, open: false })}
             anchorOrigin={{ vertical: "top", horizontal: "center" }}
           >
             <Alert
               onClose={() => setSnackbar({ ...snackbar, open: false })}
               severity={snackbar.severity}
               sx={{ width: "100%" }}
             >
               {snackbar.message}
             </Alert>
           </Snackbar>
    </div>
  );
};

export default OtherServiceAlert;
